import { Component, OnInit } from '@angular/core';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { And, BoolEquals, RuleInterface, StringListContains } from '@vendasta/automata';
import { TranslateModule } from '@ngx-translate/core';
import { map, switchMap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { BrandingService } from '../../../../../data-services/whitelabel.service';
import { CurrentAutomationService } from '@galaxy/automata/shared';

@Component({
  selector: 'automata-smb-user-verified-email-panel',
  templateUrl: './smb-user-verified-email-panel.component.html',
  styleUrls: ['./smb-user-verified-email-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
  ],
})
export class SmbUserVerifiedEmailPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  businessAppName$ = this.currentAutomationService.automation$.pipe(
    switchMap((a) => this.brandingService.getBusinessAppName(a.namespace, a.marketId)),
  );

  loadingForm$ = this.businessAppName$.pipe(map(() => false));

  constructor(
    private readonly brandingService: BrandingService,
    private readonly currentAutomationService: CurrentAutomationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.savingEnabled$.next(true);
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }

  getBaseRules(): RuleInterface[] {
    const emailVerified = new BoolEquals('{.email_verified}', true);
    const isSmb = new StringListContains('{.user_data.roles}', ['smb']);

    return [new And([emailVerified, isSmb]).toRuleInterface()];
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    return rules;
  }
}
